import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent implements OnInit {
  urlDigitada = '';
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  constructor() { }

  ngOnInit(): void {

    this.urlDigitada = this.router.url;
    this.route.params.subscribe(params => {
      console.log('URL digitada:', this.urlDigitada);
      console.log('Parâmetros da URL:', params);
    });
  }

}
